






















import { defineComponent } from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { Size } from '@front-app/components/constants';

export default defineComponent({
	components: {
		CtaButton,
		FontAwesomeIcon,
	},
	setup() {
		return {
			Size,
			ButtonPalettes,
		};
	},
});
